export default __webpack_public_path__ + "static/media/bannersweb_marzo_gmm_corazon_330x330.77d3f91c.png";